import {
  Bell,
  KeyRound,
  Palette,
  Plug,
  SlidersHorizontal,
  UserRound,
  type LucideIcon,
} from 'lucide-react'

export interface AccountRouteDefinition {
  path: string
  label: string
  shortLabel: string
  description: string
  icon: LucideIcon
}

export const ACCOUNT_ROUTES: AccountRouteDefinition[] = [
  {
    path: '/account/profile',
    label: 'Profile',
    shortLabel: 'Profile',
    description: 'Manage how you appear in Code Concierge and the App Store.',
    icon: UserRound,
  },
  {
    path: '/account/appearance',
    label: 'Appearance & dashboard',
    shortLabel: 'Appearance',
    description: 'Choose your theme, dashboard content, and application behavior.',
    icon: Palette,
  },
  {
    path: '/account/workspace',
    label: 'Workspace preferences',
    shortLabel: 'Workspace',
    description: 'Configure terminal, browser, and text-to-speech preferences.',
    icon: SlidersHorizontal,
  },
  {
    path: '/account/notifications',
    label: 'Notifications',
    shortLabel: 'Notifications',
    description: 'Choose how and when Code Concierge notifies you.',
    icon: Bell,
  },
  {
    path: '/account/connections',
    label: 'Connections',
    shortLabel: 'Connections',
    description: 'Manage linked accounts, service credentials, scopes, and AI subscriptions.',
    icon: Plug,
  },
  {
    path: '/account/api-access',
    label: 'API access',
    shortLabel: 'API',
    description: 'Create and revoke personal access tokens for scripts and automations.',
    icon: KeyRound,
  },
]

export function findAccountRoute(pathname: string): AccountRouteDefinition | undefined {
  return ACCOUNT_ROUTES.find((route) => route.path === pathname)
}
